import React from 'react';

import { GooglePayData, useGoogleDigitalCardTokenStatus } from '@/domain/digital-wallet';

import { GooglePayActivationStatusAndRedirectButton } from './components';

type GetGoingContentProps = {
    data: GooglePayData;
};

export const GetGoingContent = ({ data }: GetGoingContentProps) => {
    const { currentStatus, tokenizationError } = useGoogleDigitalCardTokenStatus(data);

    return (
        <GooglePayActivationStatusAndRedirectButton
            data={data}
            currentStatus={currentStatus}
            tokenizationError={tokenizationError}
        />
    );
};
